// src/Layout/MainLayout.jsx
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar/Sidebar';
import Header from './Header/Header';
import { SyncProvider } from '../context/SyncContext';
import { NotificationProvider } from '../context/NotificationContext';

const MainLayout = () => {
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Check if current path is login page
  const isLoginPage = location.pathname === '/login';

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const media = window.matchMedia('(min-width: 1024px)');

    const handleChange = (event) => {
      if (event.matches) {
        setSidebarOpen(false);
      }
    };

    handleChange(media);

    if (typeof media.addEventListener === 'function') {
      media.addEventListener('change', handleChange);
      return () => media.removeEventListener('change', handleChange);
    }

    media.addListener(handleChange);
    return () => media.removeListener(handleChange);
  }, []);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  return (
    <NotificationProvider>
    <SyncProvider>
      <div className="app-shell-zoom-75 flex h-screen overflow-hidden bg-gray-50">
        {!isLoginPage && (
          <Sidebar
            mobileOpen={sidebarOpen}
            onCloseMobile={() => setSidebarOpen(false)}
            collapsed={sidebarCollapsed}
            onToggleCollapsed={() => setSidebarCollapsed((value) => !value)}
          />
        )}

        {!isLoginPage && sidebarOpen && (
          <div
            className="fixed inset-0 z-40 bg-black/40 lg:hidden"
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
          />
        )}

        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          {!isLoginPage && (
            <Header
              onOpenSidebar={() => setSidebarOpen(true)}
            />
          )}

          <main className="flex-1 overflow-y-auto bg-gray-50 px-4 py-6 lg:p-4 lg:py-10">
            <Outlet />
          </main>
        </div>
      </div>
    </SyncProvider>
    </NotificationProvider>
  );
};

export default MainLayout;
